<script>
  import { goto } from "$app/navigation";
  import { cart } from "$lib/state/cart";
  import { cartTotals } from "$lib/state/cartTotals";
  import ShoppingBagItem from "../cart/ShoppingBagItem.svelte";

  /** @type {HTMLDivElement} */
  let cartModalElement;
  /**@type {boolean}*/
  let isOpenModal = false;

  /** @param {*} event*/
  function handleCartModalEscape(event) {
    if (event.code === "Escape") {
      handleShoppingDialog();
    }
  }
  function handleClickOnBody() {
    handleShoppingDialog();
  }
  /**@param {*} event */
  function stopEventPropagation(event) {
    event.stopPropagation();
  }

  const handleShoppingDialog = () => {
    if (isOpenModal) {
      document.removeEventListener("keyup", handleCartModalEscape);
      document.removeEventListener("click", handleClickOnBody);
      cartModalElement?.removeEventListener("click", stopEventPropagation);
    } else {
      document.addEventListener("keyup", handleCartModalEscape);
      document.addEventListener("click", handleClickOnBody, { once: true });
      cartModalElement.addEventListener("click", stopEventPropagation);
    }
    isOpenModal = !isOpenModal;
  };
</script>

<div class="wrapper" bind:this={cartModalElement}>
  <button class="shopping-bag-icon" on:click={handleShoppingDialog}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.492 25.525">
      <g id="Grupo_286" data-name="Grupo 286" transform="translate(0 -0.119)">
        <path
          id="Unión_2"
          data-name="Unión 2"
          d="M3,24a3,3,0,0,1-3-3V6.927a3,3,0,0,1,3-3H4.364a4.7,4.7,0,0,1,9.273,0H15a3,3,0,0,1,3,3V21a3,3,0,0,1-3,3Z"
          transform="translate(0.213 1)"
          fill="var(--global)"
        />
        <path
          id="Union_2_-_Outline"
          data-name="Union 2 - Outline"
          d="M16.243,24.133A1.859,1.859,0,0,0,18.1,22.276V7.426a1.859,1.859,0,0,0-1.856-1.856H14.767A1.392,1.392,0,0,1,13.4,4.428a3.714,3.714,0,0,0-7.3,0A1.392,1.392,0,0,1,4.725,5.569H3.249A1.859,1.859,0,0,0,1.392,7.426V22.276a1.859,1.859,0,0,0,1.856,1.856H16.243m0,1.392H3.249A3.249,3.249,0,0,1,0,22.276V7.426A3.249,3.249,0,0,1,3.249,4.177H4.725a5.106,5.106,0,0,1,10.042,0h1.476a3.249,3.249,0,0,1,3.249,3.249V22.276A3.249,3.249,0,0,1,16.243,25.525Z"
          transform="translate(0 0.119)"
          fill="var(--global)"
        />
      </g>
    </svg>
    {#if $cart && $cart.items.length > 0}
      <span class="items">{$cart?.items_qty}</span>
    {/if}
  </button>
  {#if isOpenModal}
    <div class="shopping-bag-content">
      {#if $cart && $cart.items.length > 0}
        <ul>
          {#each $cart?.items as item}
            <ShoppingBagItem {item} />
          {/each}
        </ul>
      {:else}
        <p class="msg-empty">
          <b style="color: var(--global)">
            Your bag is empty!<br />
          </b>
          Add products to bag, and get great offers!
        </p>
      {/if}
      {#if $cartTotals}
        <button class="btn-action-url" on:click={() => goto("/cart")}>
          <span>GO TO BAG</span>
        </button>
      {/if}
    </div>
  {/if}
</div>

<style>
  .wrapper {
    position: relative;
  }
  .shopping-bag-icon {
    width: 1.9rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: 0;
    position: relative;
    cursor: pointer;
  }
  .shopping-bag-icon svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
  .items {
    position: absolute;
    top: 58%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--white);
  }
  .shopping-bag-content {
    position: absolute;
    background: white;
    /* display: grid;
    grid-template-rows: 1fr 7rem; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    max-width: 38rem;
    width: 95svw;
    padding: 3rem;
    gap: 1.5rem;
    right: 0;
    top: 4.5rem;
    box-shadow: 0px 0.3rem 0.6rem rgba(124, 115, 115, 0.75);
    z-index: 50;
    border-radius: 3rem 0 3rem 3rem;
    animation: popShoppingBag 500ms ease forwards;
    transition: all 0.5s ease;
    overflow: hidden;
    max-height: 64rem;
  }
  .shopping-bag-content ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    animation: all 0.5s ease;
    gap: 1rem;
    overflow-y: auto;
    scrollbar-width: none;
    height: 100%;
    padding: 2rem 0;
  }
  .shopping-bag-content ul::-webkit-scrollbar {
    width: 0;
  }
  .msg-empty {
    text-align: center;
    font-size: 1.8rem;
    padding: 1.5rem 0;
  }
  .msg-empty b {
    font-size: 2rem;
    font-family: sirenia;
  }

  @keyframes popShoppingBag {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }
    45% {
      transform: scale(1.05);
      opacity: 1;
    }
    80% {
      transform: scale(0.95);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
